import React__default from 'react';
import classNames from 'classnames';
import styles from './Backdrop.scss.mjs';

function Backdrop({
  show = false,
  fullscreen = false
}) {
  const backdropClassNames = classNames(styles.Backdrop, {
    [styles.show]: show,
    [styles.fullscreen]: fullscreen
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: backdropClassNames,
    "aria-hidden": "true"
  });
}

export { Backdrop };
